/**
 * Ocultar el Asistente Web (el chatbot que inyecta el loader del core) SIN tocar su estado.
 *
 * Antes se ponía `display:none` a mano en su botón y en su panel, y se devolvía `display=''`
 * al enseñarlos. Pero el loader también escribe ese `display` (abre el panel con `block` al
 * pulsar o con la apertura automática, 3 s después de cargar), así que los dos se pisaban:
 *  - entrando por la home y saliendo antes de que saltara la apertura automática, el panel
 *    aparecía abierto en otra página con el botón oculto (el chat sin su burbuja);
 *  - al volver a la home, `display=''` quitaba el `display:none` de partida del panel y se
 *    veía abierto aunque el loader lo tuviera cerrado (y el botón perdía su `display:flex`).
 *
 * Ahora se oculta con una regla CSS `!important` que se activa con un atributo en <body>: el
 * loader sigue abriendo y cerrando a su aire y, al dejar de ocultar, se ve justo su estado.
 * Varios motivos a la vez (la ruta, el kit de IA, la demo…): se oculta mientras quede alguno.
 *
 * El loader añade al <body> su botón (aria-haspopup="dialog"), su panel (role="dialog") y la
 * burbuja de reclamo (un div con z-index 2147482999, uno menos que el botón): no llevan clase
 * ni id. El botón de WhatsApp NO se toca: es otro widget.
 */
const ATTR = 'data-invoke-chat-hidden';
const STYLE_ID = 'invoke-chat-hidden-style';
const reasons = new Set();

const ensureStyle = () => {
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = [
    `body[${ATTR}] > button[aria-haspopup="dialog"]`,
    `body[${ATTR}] > div[role="dialog"]`,
    `body[${ATTR}] > div[style*="2147482999"]`,
  ].join(',\n') + ' { display: none !important; }';
  document.head.appendChild(style);
};

const sync = () => {
  if (reasons.size > 0) document.body.setAttribute(ATTR, '');
  else document.body.removeAttribute(ATTR);
};

export const hideFloatingWidgets = (reason) => {
  if (typeof document === 'undefined') return;
  ensureStyle();
  reasons.add(reason);
  sync();
};

export const showFloatingWidgets = (reason) => {
  if (typeof document === 'undefined') return;
  reasons.delete(reason);
  sync();
};
